module.exports = __webpack_public_path__ + "img/espaco5.2ce80781.jpeg";